import { render } from "./EscritorioAsignaciones.vue?vue&type=template&id=e9e87038"
import script from "./EscritorioAsignaciones.vue?vue&type=script&lang=js"
export * from "./EscritorioAsignaciones.vue?vue&type=script&lang=js"

import "./EscritorioAsignaciones.vue?vue&type=style&index=0&id=e9e87038&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__